import moment from "moment";
import React from "react";

const tableHeaderColumns = ["ID", "Role", "Status", "Posted", "Last Active"];

const data = [
  {
    id: 1,
    jobTitle: "Software Engineer",
    status: "Active",
    posted: "2022-01-01",
    lastActive: "2022-03-15",
  },
  {
    id: 2,
    jobTitle: "Product Manager",
    status: "Active",
    posted: "2022-02-01",
    lastActive: "2022-03-17",
  },
  {
    id: 3,
    jobTitle: "UX Designer",
    status: "Active",
    posted: "2022-03-01",
    lastActive: "2022-03-19",
  },
  {
    id: 4,
    jobTitle: "Marketing Specialist",
    status: "Filled",
    posted: "2022-02-15",
    lastActive: "2022-03-14",
  },
  {
    id: 5,
    jobTitle: "Data Analyst",
    status: "Active",
    posted: "2022-03-10",
    lastActive: "2022-03-16",
  },
  {
    id: 6,
    jobTitle: "Operations Manager",
    status: "Active",
    posted: "2022-02-20",
    lastActive: "2022-03-18",
  },
  {
    id: 7,
    jobTitle: "Full Stack Developer",
    status: "Filled",
    posted: "2022-02-28",
    lastActive: "2022-03-20",
  },
  {
    id: 8,
    jobTitle: "Accountant",
    status: "Active",
    posted: "2022-03-05",
    lastActive: "2022-03-13",
  },
  {
    id: 9,
    jobTitle: "Sales Representative",
    status: "Active",
    posted: "2022-01-15",
    lastActive: "2022-03-16",
  },
  {
    id: 10,
    jobTitle: "Graphic Designer",
    status: "Filled",
    posted: "2022-03-01",
    lastActive: "2022-03-19",
  },
];

export default function OrdersTablePreview() {
  const columnWidths = ["2.5%", "27.5%", "10%", "25%", "25%"];

  return (
    <table className="w-full text-sm text-left text-gray-700 dark:text-gray-400">
      <thead className="text-sm text-gray-900 bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
        {tableHeaderColumns.map((column) => (
          <th scope="col" className="px-6 py-3">
            <button>{column}</button>
          </th>
        ))}
      </thead>
      <tbody>
        {data &&
          data.map((dataItem) => (
            <tr
              className="cursor-pointer bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600"
              key={dataItem.accountId}
            >
              <td className="px-6 py-2" style={{ width: columnWidths[0] }}>
                {dataItem.id}
              </td>
              <td className="px-6 py-2" style={{ width: columnWidths[1] }}>
                {dataItem.jobTitle}
              </td>
              <td className="px-6 py-2" style={{ width: columnWidths[2] }}>
                {dataItem.status}
              </td>
              <td className="px-6 py-2" style={{ width: columnWidths[3] }}>
                {moment(dataItem.posted).format("ddd, MMM Do")}
              </td>
              <td className="px-6 py-2" style={{ width: columnWidths[4] }}>
                {moment(dataItem.lastActive).format("ddd, MMM Do")}
              </td>
            </tr>
          ))}
      </tbody>
    </table>
  );
}
